export default __webpack_public_path__ + "static/23-b1bc6f172035df68d3321f00e06876a0.jpg";